import React from 'react';
import LinkButton from '../atoms/LinkButton';

const FeaturedArticle = ({ title, excerpt, link, date, featured = false }) => {
  if (featured) {
    return (
      <div className="bg-gradient-to-r from-navy to-blue-800 shadow-xl rounded-lg overflow-hidden text-white">
        <div className="p-8">
          <div className="flex items-center mb-4">
            <span className="bg-yellow text-navy px-3 py-1 rounded-full text-sm font-bold">
              FEATURED
            </span>
          </div>
          <h3 className="text-3xl font-bold mb-4">{title}</h3>
          {date && <p className="text-sm text-yellow/90 mb-4">{date}</p>}
          <p className="text-gray-100 mb-6 text-lg">{excerpt}</p>
          <LinkButton
            to={link}
            target="_blank"
            variant="primary"
            className="inline-flex items-center"
          >
            Read Full Article
            <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </LinkButton>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-shadow">
      <div className="p-6">
        <h3 className="text-2xl font-bold mb-4">{title}</h3>
        {date && <p className="text-sm text-gray-500 mb-3">{date}</p>}
        <p className="text-gray-600 mb-4">{excerpt}</p>
        <a
          href={link}
          className="text-blue-600 underline hover:no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow font-semibold inline-flex items-center"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn More
          <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default FeaturedArticle;
